import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { ngxLoadingAnimationTypes } from "ngx-loading";
import { PraService } from "../services/pra.service";
import { FormatDataService } from "../services/format-data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../environments/environment";
import { first } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../services/authentication.service";
//Format Time with momentJS
import * as moment from "moment";
//lodash
import * as _ from 'lodash';
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-pra-details",
  templateUrl: "./pra-details.component.html",
  styleUrls: ["./pra-details.component.css"],
})
export class PraDetailsComponent implements OnInit {
  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  //Error handling
  consentErrMsg: string;

  //Alerts
  showErrorAlert: boolean = false;

  params: any;

  //Current User
  currentUser: any;

  //Detail variables
  employeeName: string;
  employeeID: number;
  workingStoreID: number;
  homeStoreID: number;
  homeState: string;
  requestorEID: number;
  requestorName: string;
  requestStatus: string;
  requestID: number;
  selectedWeek: any;
  praDetails: any;
  createdOn: any;
  comments: string;
  changeDate: any;
  totalHours: any;
  commentsCancel: string = null;
  state: string;
  workLegionEffDate: any;
  homeLegionEffDate: any;
  totalFileSize: number;

  //Lists
  detailsList: any;
  punchRecordsToView: any;
  punchRecordsTotalHoursPerDay: any;
  documentList: any = [];

  //Modals
  modalOption: NgbModalOptions = {};
  modalCancel: NgbModalRef;
  modalCancelConfirm: NgbModalRef;
  modalComplete: NgbModalRef;
  modalCompleteConfirm: NgbModalRef;
  modalDoc: NgbModalRef;
  closeResult: string;

  //Flags
  showCancelButton: boolean = false;
  showCompleteButton: boolean = false;
  showInstructionsToCancelCompletedRequest: boolean = false;
  showMealBreakAlert: string = null;
  showDeleteDocConfirmation: number;
  showDeleteLoader: number;
  showFileLimit: boolean = false;
  showFileSizeLimit: boolean = false;
  showFileSizeMultipleLimit: boolean = false;

  //Upload Files
  myFiles: string[] = [];
  @ViewChild('fileUploader') fileUploader: ElementRef;


  constructor(
    private praService: PraService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private formatDataService: FormatDataService,
    private httpClient: HttpClient
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.params = params;

      this.getdetails();
      this.getTotalHoursPerDay();
      this.getDocList();
    });

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    //Modal Options
    this.modalOption.backdrop = "static";
    this.modalOption.keyboard = false;

    //Remove any instruction views
    this.showInstructionsToCancelCompletedRequest = false;
  }

  getdetails() {
    this.loading = true;
    console.log(this.params.ID);
    const result = this.praService
      .getPRADetails(parseInt(this.params.ID))
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          this.detailsList = data;
          this.employeeName = data.EmployeeName;
          this.employeeID = data.EmployeeID;
          this.workingStoreID = data.WorkingStoreID;
          this.homeStoreID = data.HomeStoreID;
          this.homeState = data.State;
          this.requestorEID = data.RequestorEmployeeID;
          this.requestorName = data.RequestorEmployeeName;
          this.requestStatus = data.RequestStatus;
          this.requestID = data.PRARequestID;
          this.selectedWeek = data.SelectedWeek;
          this.praDetails = data.PRADetails;
          console.log(this.praDetails);
          this.createdOn = data.CreatedOn;
          this.comments = data.Comments;
          this.changeDate = data.ChangeDate;
          this.state = data.State;
          this.workLegionEffDate = data.WorkStore_LegionEffDate;
          this.homeLegionEffDate = data.HomeStore_LegionEffDate;
          this.commentsCancel = data.CancelComments;
          console.log(data);

          //Create data model to show hours
          this.punchRecordsToView = [];

          for (let index in this.praDetails) {
            let hours = this.formatDataService.getPunchHoursForDetailsPage(
              this.praDetails[index].PunchIn,
              this.praDetails[index].PunchOut
            );
            if (hours > 4 && this.state == "CA") {
              //Removed Meal Break Alert - Keep logic for future use
              this.showMealBreakAlert = "";
            } else {
              this.showMealBreakAlert = null;
            }

            this.punchRecordsToView.push({
              BusinessDate: this.praDetails[index].BusinessDate,
              PunchIn: this.praDetails[index].PunchIn,
              PunchOut: this.praDetails[index].PunchOut,
              Minutes: this.praDetails[index].TotalMinutes,
              Hours: this.formatDataService.getPunchHoursForDetailsPage(
                this.praDetails[index].PunchIn,
                this.praDetails[index].PunchOut
              ),
              MeakBreakAlert: this.showMealBreakAlert,
            });
          }
          console.log(this.punchRecordsToView);

          //Show total hours
          var hoursArray = [];
          for (let index in this.punchRecordsToView) {
            hoursArray.push(this.punchRecordsToView[index].Minutes);
          }
          const sum = hoursArray.reduce(add, 0); // with initial value to avoid when the array is empty

          function add(accumulator, a) {
            return accumulator + a;
          }

          this.totalHours = this.formatDataService
            .formatMinutesToHours(sum)
            .toFixed(2);

          //Show buttons
          switch (this.requestStatus) {
            case "Submitted":
              // if you user not payroll admin and canRequestNew is false
              console.log(this.requestorEID);
              console.log(this.currentUser.employeeId);
              if (
                this.currentUser.payrollsuperadmin
              ) {
                this.showCancelButton = true;
              } else if (
                this.currentUser.canRequestNew == false &&
                this.currentUser.payrolladmin == false
              ) {
                this.showCancelButton = false;
              } else if (
                this.currentUser.canRequestNew == true &&
                this.requestorEID !== this.currentUser.employeeId
              ) {
                this.showCancelButton = false;
              } else {
                this.showCancelButton = true;
              }

              // if you user is payroll admin then show the complete button
              if (this.currentUser.payrolladmin || this.currentUser.payrollsuperadmin) {
                this.showCompleteButton = true;
              }
              break;
            case "Completed":
              // if you user is payroll admin and today's date = the change date then allow user to cancel
              if (
                this.currentUser.payrolladmin == true &&
                moment().format("YYYYMMDD") ==
                moment(this.changeDate).format("YYYYMMDD")
              ) {
                this.showCancelButton = true;
              } else if (
                this.currentUser.payrollsuperadmin == true &&
                moment().format("YYYYMMDD") ==
                moment(this.changeDate).format("YYYYMMDD")
              ) {
                this.showCancelButton = true;
              }
              break;
          }

          //Show instructions to cancel for completed requests
          if (
            this.requestStatus == "Completed" &&
            this.showCancelButton == false
          ) {
            this.showInstructionsToCancelCompletedRequest = true;
          }

          if (data.isSuccess) {
            console.log("success!");
          } else {
            if (data.ErrMessage) {
              this.consentErrMsg = data.ErrMessage;
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            } else {
              this.consentErrMsg =
                "Something went wrong, please contact your administrator.";
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            }
          }
        },
        (error) => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(["/login"]);
          } else {
            console.log("API ERROR:");
            console.log(error);
          }
        }
      );
  }

  getTotalHoursPerDay() {
    this.loading = true;
    console.log(this.params.ID);
    const result = this.praService
      .getPRADetailsPlusTotal(parseInt(this.params.ID))
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          this.punchRecordsTotalHoursPerDay = data.PRADetails;
          console.log(this.punchRecordsTotalHoursPerDay);

          if (data.isSuccess) {
            console.log("success!");
          } else {
            if (data.ErrMessage) {
              this.consentErrMsg = data.ErrMessage;
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            } else {
              this.consentErrMsg =
                "Something went wrong, please contact your administrator.";
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            }
          }
        },
        (error) => {
          if (error.status === 401 || error.status === 500) {
            console.log("error status");
          } else {
            console.log(
              "Something went wrong, please contact your administrator:" + error
            );
          }
        }
      );
  }

  openCancelAlert(modal) {
    //Clear upload file list
    this.myFiles = [];

    this.modalCancel = this.modalService.open(modal);
    this.modalCancel.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openCompleteAlert(modal) {
    this.modalComplete = this.modalService.open(modal);
    this.modalComplete.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  cancelPRARequest(modal) {
    this.loading = true;

    const result = this.praService
      .cancelPRARequest(
        this.requestID,
        this.currentUser.employeeId,
        this.commentsCancel
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          console.log(data);
          if (data == true) {
            console.log("success!");
            this.modalCancel.close();
            this.modalCancelConfirm = this.modalService.open(
              modal,
              this.modalOption
            );
            this.modalCancelConfirm.result.then(
              (result) => {
                this.closeResult = `Closed with: ${result}`;
              },
              (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              }
            );
          } else {
            if (data.ErrMessage) {
              this.loading = false;
              this.consentErrMsg = data.ErrMessage;
              this.showErrorAlert = true;
              this.modalCancel.close();
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            } else {
              this.loading = false;
              this.consentErrMsg =
                "Something went wrong, please contact your administrator.";
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            }
          }
        },
        (error) => {
          this.loading = false;
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(["/login"]);
          } else {
            this.consentErrMsg =
              "Something went wrong, please contact your administrator:" +
              error;
          }
        }
      );
  }

  completePRARequest(modal) {
    this.loading = true;
    const result = this.praService
      .completePRARequest(this.requestID, this.currentUser.employeeId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          console.log(data);
          if (data.isSuccess == true) {
            console.log("success!");
            this.modalComplete.close();
            this.modalCompleteConfirm = this.modalService.open(
              modal,
              this.modalOption
            );
            this.modalCompleteConfirm.result.then(
              (result) => {
                this.closeResult = `Closed with: ${result}`;
              },
              (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              }
            );
          } else {
            if (data.ErrMessage) {
              this.consentErrMsg = data.ErrMessage;
              this.showErrorAlert = true;
              this.modalComplete.close();
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            } else {
              this.consentErrMsg =
                "Something went wrong, please contact your administrator.";
              //setTimeout(function(){ this.showErrorAlert = false; }, 3000);
              console.log(this.consentErrMsg);
            }
          }
        },
        (error) => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(["/login"]);
          } else {
            this.consentErrMsg =
              "Something went wrong, please contact your administrator:" +
              error;
          }
        }
      );
  }

  back() {
    //Determine if search was a basic search or eid search and go back to the appropriate page
    if (
      this.params.searchType !== undefined &&
      this.params.searchType == "eid"
    ) {
      this.router.navigate(["/view-adjustment-records/search-eid"], {
        queryParams: {
          ID: this.params.ID,
          EID: this.employeeID,
        },
      });
    } else {
      let processLevel: string;
      if (this.params.ProcessLevel == "- - All - -") {
        processLevel = "";
      } else {
        processLevel = this.params.ProcessLevel;
      }

      this.router.navigate(["/view-adjustment-records"], {
        queryParams: {
          ID: this.params.ID,
          Region: this.params.Region,
          RegionIndex: this.params.RegionIndex,
          Store: this.params.Store,
          StoreIndex: this.params.StoreIndex,
          EID: this.params.EID,
          EmployeeName: this.params.EmployeeName,
          EmployeeIndex: this.params.EmployeeIndex,
          Status: this.params.Status,
          StartDateMonth: this.params.StartDateMonth,
          StartDateDay: this.params.StartDateDay,
          StartDateYear: this.params.StartDateYear,
          EndDateMonth: this.params.EndDateMonth,
          EndDateDay: this.params.EndDateDay,
          EndDateYear: this.params.EndDateYear,
          StatusIndex: this.params.StatusIndex,
          ProcessLevel: processLevel,
        },
      });
    }

    if (this.modalCancelConfirm !== undefined) {
      this.modalCancelConfirm.close();
    }

    if (this.modalCompleteConfirm !== undefined) {
      this.modalCompleteConfirm.close();
    }
  }

  getFileDetails(e) {
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;
    console.log(e);
    console.log(e.target.files);
    console.log(`Total size: ${_.sumBy(e.target.files, 'size')}`);
    console.log(this.myFiles);
    for (var i = 0; i < e.target.files.length; i++) {
      let currentTotal = _.sumBy(this.myFiles, 'size') + e.target.files[i].size
      //get current file size total
      console.log(currentTotal);
      //Don't allow file names greater than 50 characters
      if (e.target.files[i].name.length > 50) {
        console.log("File character too long")
        this.showFileLimit = true;
      } else if (currentTotal > 2000000) {
        this.showFileSizeMultipleLimit = true;
      } else if (e.target.files[i].name.size > 2000000) {
        this.showFileSizeLimit = true;
      } else {
        this.myFiles.push(e.target.files[i]);
        this.showFileLimit = false;
        this.showFileSizeLimit = false;
        this.showFileSizeMultipleLimit = false;
      }

    }
    console.log(this.myFiles);
    console.log(`Total my files: ${_.sumBy(this.myFiles, 'size')}`);
    this.totalFileSize = _.sumBy(this.myFiles, 'size');
  }

  checkUpload(type, modal) {
    console.log(type);
    //Look if there are files to upload
    if (this.myFiles.length > 0) {
      this.uploadFiles(type, modal);
    } else {
      if (type == "cancel") {
        console.log('cancel')
        this.cancelPRARequest(modal)
      }
      if (type == "complete") {
        console.log('complete')
        this.completePRARequest(modal);
      }

    }

  }

  uploadFiles(type, modal) {
    this.loading = true;

    const frmData = new FormData();

    for (var i = 0; i < this.myFiles.length; i++) {
      frmData.append("uploadDocument", this.myFiles[i]);
    }
    console.log(frmData)

    this.httpClient.post<any>(`${environment.serverUrl}/api/Data/UploadDocuments?RequestID=${this.params.ID}&SubjectEid=${this.employeeID}&AuditEid=${this.currentUser.employeeId}`, frmData
    ).subscribe(
      data => {
        //Proceed with cancel or complete
        if (type == "cancel") {
          this.cancelPRARequest(modal)
        }
        if (type == "complete") {
          this.completePRARequest(modal);
        }

        // SHOW A MESSAGE RECEIVED FROM THE WEB API.
        console.log(data);

      },
      (error) => {
        this.loading = false;
        console.log(error.message);    // Show error, if any.
      }
    );
  }

  removeFile(index) {
    //clear alerts
    this.showFileLimit = false;
    this.showFileSizeLimit = false;
    this.showFileSizeMultipleLimit = false;
    //remove file from list
    const removeFile = this.myFiles
    removeFile.splice(index, 1);
    this.myFiles = removeFile
    console.log(this.myFiles);
    //recalculate total file size
    this.totalFileSize = _.sumBy(this.myFiles, 'size');
  }

  getDocList() {
    this.praService.getDocList(
      this.params.ID
    )
      .subscribe(
        data => {
          console.log(data)
          this.documentList = data
        },
        error => {
          if (error.status === 401 || error.status === 500) {
          } else {
            console.log(error)
          }
        })
  }

  openDocModal(modal) {
    this.modalDoc = this.modalService.open(modal);
    this.modalDoc.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  docConfirmDelete(index) {
    this.showDeleteDocConfirmation = index
  }

  cancelDocDelete() {
    this.showDeleteDocConfirmation = null
  }

  deleteDoc(docId, index) {
    //show loader
    this.showDeleteLoader = index

    this.praService.deleteDocById(
      docId,
      this.currentUser.employeeId
    )
      .subscribe(
        data => {
          //remove loader
          this.showDeleteLoader = null

          //remove file from list
          const deleteList = this.documentList
          deleteList.splice(index, 1);
          this.documentList = deleteList
          console.log(this.documentList);

          //remove delete confirmation view
          this.showDeleteDocConfirmation = null

          console.log(data)
        },
        error => {
          if (error.status === 401 || error.status === 500) {
          } else {
            alert(error)
          }
        })
  }

  openDoc(i) {
    const documentID = this.documentList[i].DocumentID;
    const documentName = this.documentList[i].DocumentFileName;
    this.praService.getDocById(documentID, documentName).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = documentName;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        if (error.status === 401) {
          this.authenticationService.logout();
          this.router.navigate(["/login"]);
        } else {
          console.log(error);
        }
      }
    );
  }


}
